<template>
  <div class="allignment">
    <div class="windowManagementButtons">
      <div class="circle transform">
        <svg width="10" height="10">
        <line x1="0" y1="11" x2="100" y2="11" stroke="black" stroke-width="5" />
      </svg>
      </div>
      <div class="circle transform">
        <!--p>4</p-->
        <svg width="10" height="10">
          <rect
            width="20"
            height="20"
            fill="white"
            style="stroke-width: 3; stroke: black"
          />
        </svg>
      </div>
      <div class="circle close">
            <svg class="svg-icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <path d="M810.65984 170.65984q18.3296 0 30.49472 12.16512t12.16512 30.49472q0 18.00192-12.32896 30.33088l-268.67712 268.32896 268.67712 268.32896q12.32896 12.32896 12.32896 30.33088 0 18.3296-12.16512 30.49472t-30.49472 12.16512q-18.00192 0-30.33088-12.32896l-268.32896-268.67712-268.32896 268.67712q-12.32896 12.32896-30.33088 12.32896-18.3296 0-30.49472-12.16512t-12.16512-30.49472q0-18.00192 12.32896-30.33088l268.67712-268.32896-268.67712-268.32896q-12.32896-12.32896-12.32896-30.33088 0-18.3296 12.16512-30.49472t30.49472-12.16512q18.00192 0 30.33088 12.32896l268.32896 268.67712 268.32896-268.67712q12.32896-12.32896 30.33088-12.32896z"  />
            </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WindowButtons",
  props: {
    msg: String,
  },
};
</script>

<style scoped>
p{
  color: black;
}
.allignment {
 /** position: absolute;*/
  /**right: 0.5%;
  top: 0.7%;*/
  text-color:black;
}
.windowManagementButtons {
  display: flex;
  right: 0%;
  gap: 2px;
}
.circle {
  display: flex;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.close {
  background-color: red;
}
.transform {
  background-color: darkgray;
  text-align: center;
}
</style>